
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Fortuneronrentinpune() {



    const cardData =
    {
        keyword: '  Fortuner On Rent in Pune',
        heading: 'Skyline Cabs:  Fortuner On Rent in Pune',
        headingDescription: 'Skyline Cabs offers premium Fortuner on Rent in Pune for those seeking a powerful and luxurious travel experience. Ideal for business travel, VIP transfers, weddings, or outstation trips, our well-maintained Toyota Fortuner SUVs provide top-notch comfort, advanced features, and a commanding road presence. With professional chauffeurs, flexible rental packages, transparent pricing, and 24/7 customer support, Skyline Cabs ensures a seamless and elite journey. Book your Fortuner in Pune today and travel in style, strength, and sophistication.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    
    
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
    {
      "name": "Fortuner on Rent Pune",
      "description": "Skyline Cabs provides Toyota Fortuner on rent in Pune for all types of travel—be it leisure, business, or special occasions. Enjoy a luxurious ride with ample space, comfort, and reliability."
    },
    {
      "name": "Toyota Fortuner Rental in Pune",
      "description": "Rent a premium Toyota Fortuner in Pune with Skyline Cabs. Ideal for corporate clients and VIP guests, this SUV delivers elegance and performance with experienced chauffeur services."
    },
    {
      "name": "Toyota Fortuner Rental in Pune Airport",
      "description": "Get a Toyota Fortuner at Pune Airport with Skyline Cabs for your executive or family pick-up. Enjoy seamless airport transfers with professional service and flexible booking options."
    },
    {
      "name": "Toyota Fortuner Rental in Pune Airport Contact Number",
      "description": "For Fortuner bookings at Pune Airport, contact Skyline Cabs at [Insert Number]. We provide timely pickups, premium vehicles, and transparent pricing for a smooth journey."
    },
    {
      "name": "Toyota Fortuner Hire for Corporate Events",
      "description": "Make a bold impression at your next business event with Skyline Cabs’ Fortuner hire. Available across Pune, our SUV rentals ensure a stylish arrival for corporate executives and clients."
    },
    {
      "name": "Toyota Fortuner Hire for Corporate Events Near Me",
      "description": "Looking for a Fortuner rental for a business meeting or conference near you? Skyline Cabs offers localized bookings in Pune and Pimpri Chinchwad with top-class service and punctuality."
    },
    {
      "name": "Toyota Fortuner Hire for Wedding Function",
      "description": "Book a Toyota Fortuner for your wedding with Skyline Cabs. Perfect for groom entry or family transport, the Fortuner adds elegance and style to your big day."
    },
    {
      "name": "Fortuner on Rent for Wedding",
      "description": "Skyline Cabs offers Fortuner rentals for weddings across Pune and Mumbai. With driver service and decorative options available, make a grand wedding entrance in this luxurious SUV."
    },
    {
      "name": "Fortuner Rent for One Day",
      "description": "Need a Fortuner just for a day? Skyline Cabs provides short-term SUV rentals in Pune with affordable one-day packages, perfect for special events or quick outstation trips."
    },
    {
      "name": "Fortuner Hire in Pimpri Chinchwad",
      "description": "Skyline Cabs offers Toyota Fortuner hire in Pimpri Chinchwad for weddings, corporate events, and outstation trips. Enjoy reliable service, clean vehicles, and experienced drivers."
    },
    {
      "name": "Fortuner on Rent for Outstation",
      "description": "Travel in luxury for your outstation journeys with Fortuner rentals from Skyline Cabs. Spacious interiors and smooth rides make it ideal for family and business trips outside Pune."
    },
    {
      "name": "Fortuner Hire for Corporate Office",
      "description": "Skyline Cabs provides Fortuner SUV rentals for business executives traveling to or from corporate offices in Pune. On-time service, privacy, and comfort are our priorities."
    },
    {
      "name": "Fortuner on Rent in Pune Monthly",
      "description": "Looking for a monthly rental plan for Toyota Fortuner in Pune? Skyline Cabs offers flexible long-term rental solutions for businesses, NRI clients, and extended travel plans."
    },
    {
      "name": "Fortuner Rent Per Km",
      "description": "Skyline Cabs offers Fortuner rentals in Pune and Mumbai on a per km basis. Transparent pricing, no hidden charges, and professional chauffeurs ensure a premium experience."
    },
    {
      "name": "Fortuner on Rent in Mumbai",
      "description": "Book a Toyota Fortuner in Mumbai with Skyline Cabs. Ideal for airport transfers, events, and outstation trips, our service ensures you travel in comfort and style."
    },
    {
      "name": "Toyota Fortuner on Rent in Mumbai",
      "description": "Skyline Cabs offers Fortuner rentals in Mumbai with top-tier service. Enjoy corporate transfers, weddings, and weekend getaways in this robust and elegant SUV."
    }
  ],
  "tableData": [
    ["Fortuner on Rent Pune", "Toyota Fortuner Rental in Pune"],
    ["Toyota Fortuner Rental in Pune Airport", "Toyota Fortuner Rental in Pune Airport Contact Number"],
    ["Toyota Fortuner Hire for Corporate Events", "Toyota Fortuner Hire for Corporate Events Near Me"],
    ["Toyota Fortuner Hire for Wedding Function", "Fortuner on Rent for Wedding"],
    ["Fortuner Rent for One Day", "Fortuner Hire in Pimpri Chinchwad"],
    ["Fortuner on Rent for Outstation", "Fortuner Hire for Corporate Office"],
    ["Fortuner on Rent in Pune Monthly", "Fortuner Rent Per Km"],
    ["Fortuner on Rent in Mumbai", "Toyota Fortuner on Rent in Mumbai"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Premium Fortuner Rental in Pune",
        "WhyChoosedescription": "Experience luxury and performance with our Fortuner rental service in Pune. Whether it’s for business travel, family trips, or outstation journeys, the Fortuner offers unmatched comfort and power."
    },
    {
        "WhyChooseheading": "Spacious and Stylish SUV",
        "WhyChoosedescription": "With plush interiors, high ground clearance, and ample luggage space, the Fortuner is ideal for long road trips or city travel. Its bold design and premium features offer a stylish and commanding presence."
    },
    {
        "WhyChooseheading": "Perfect for All Terrain Travel",
        "WhyChoosedescription": "Equipped with powerful engine performance and 4x4 capabilities, the Fortuner handles highways, ghats, and rugged terrains with ease—making it a perfect SUV for adventure seekers and comfort lovers alike."
    },
    {
        "WhyChooseheading": "Professional Chauffeurs for a Smooth Ride",
        "WhyChoosedescription": "All our Fortuner rentals come with professional, well-trained drivers who ensure safety, punctuality, and a smooth journey—whether you're heading to a corporate meeting or a weekend getaway."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
        "WhyChoosedescription": "Our Fortuner on rent in Pune comes with fixed pricing that includes fuel, tolls, and driver allowance. No hidden charges—just honest service with top-tier luxury."
    },
    {
        "WhyChooseheading": "Ideal for Business & Leisure Travel",
        "WhyChoosedescription": "Impress clients or enjoy a premium family outing—Fortuner rentals are perfect for both corporate and leisure travel in and around Pune."
    },
    {
        "WhyChooseheading": "Easy Booking and Instant Confirmation",
        "WhyChoosedescription": "Book your Fortuner in just a few clicks via our website or call support. Get instant confirmation and trip details, with flexible booking options available."
    },
    {
        "WhyChooseheading": "Sanitized and Well-Maintained Vehicles",
        "WhyChoosedescription": "Every Fortuner in our fleet is thoroughly cleaned, sanitized, and maintained for top-notch performance and hygiene. Your safety and comfort are our priorities."
    }
]











    }

    const faqData = [
        {
            id: 1,
            question: 'How can I rent a Fortuner in Pune with Skyline Cabs?',
            answer:
                'Renting a Fortuner in Pune is easy with Skyline Cabs. Just visit our website, use our mobile app, or call our customer support. Choose Fortuner as your vehicle, enter your travel details, and confirm your booking.',
        },
        {
            id: 2,
            question: 'Why should I rent a Fortuner in Pune?',
            answer:
                'The Toyota Fortuner is a luxury SUV offering top-tier comfort, power, and safety. It’s ideal for business travel, VIP transfers, family road trips, and outstation travel where style and performance matter.',
        },
        {
            id: 3,
            question: 'Is the Fortuner available for local and outstation trips in Pune?',
            answer:
                'Yes, you can rent a Fortuner for both local use within Pune and long-distance outstation trips to places like Mumbai, Lonavala, Goa, Shirdi, and more.',
        },
        {
            id: 4,
            question: 'Are the rental prices for Fortuner in Pune fixed?',
            answer:
                'Yes, Skyline Cabs provides fixed and transparent pricing for Fortuner rentals. Your fare includes driver charges, tolls, and taxes—no hidden fees.',
        },
        {
            id: 5,
            question: 'Can I book the Fortuner for a one-way trip from Pune?',
            answer:
                'Yes, one-way rentals are available for the Fortuner. Whether it’s Pune to Mumbai or any other city, you can choose one-way travel at the time of booking.',
        },
        {
            id: 6,
            question: 'Is the Fortuner suitable for corporate or VIP travel?',
            answer:
                'Absolutely! The Fortuner is a premium SUV that’s frequently used for corporate transfers, VIP guests, and executives needing both comfort and luxury on the go.',
        },
        {
            id: 7,
            question: 'Are Fortuner vehicles well-maintained and clean?',
            answer:
                'Yes, our Fortuner fleet is regularly maintained and professionally cleaned. We ensure every vehicle meets high standards of hygiene and performance.',
        },
        {
            id: 8,
            question: 'What are the payment options for Fortuner rental in Pune?',
            answer:
                'We offer secure payment options including UPI, credit/debit cards, net banking, and cash payments after the ride. You choose what’s convenient for you.',
        },
        {
            id: 9,
            question: 'Can I cancel or reschedule my Fortuner rental?',
            answer:
                'Yes, we provide flexible cancellation and rescheduling options. You can make changes easily via our website, app, or by contacting customer support.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for Fortuner rental in Pune?',
            answer:
                'Skyline Cabs ensures a premium rental experience with well-maintained Fortuner SUVs, professional chauffeurs, fixed pricing, and round-the-clock support. Enjoy luxury and reliability with every trip.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Verma",
            rating: 5,
            review: "Rented a Fortuner in Pune for a client meeting in Mumbai. The vehicle was in excellent condition and made a great impression. Professional driver and punctual service!"
        },
        {
            name: "Miss. Sonal Gupta",
            rating: 4,
            review: "Fortuner was the perfect ride for our family trip to Mahabaleshwar. Super spacious, comfortable, and the booking process was smooth. Highly recommended!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Fortuner on Rent in Pune",
  "image": "https://skylinecabs.com/assets/images/fortuner-on-rent-pune.jpg",
  "description": "Rent Toyota Fortuner in Pune with Skyline Cabs for a luxurious and powerful travel experience. Ideal for VIP travel, business meetings, weddings, and outstation trips — chauffeur-driven and available 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8271"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6000",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/fortuner-on-rent-in-pune"
  }
};


    
      

    return (
        <div>
 
<Helmet>
  <title>Fortuner on Rent in Pune | Luxury SUV Rental 24/7 | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Rent Toyota Fortuner in Pune with Skyline Cabs for a luxurious and powerful travel experience. Ideal for VIP travel, business meetings, weddings, and outstation trips — chauffeur-driven and available 24/7." 
  />
  <meta 
    name="keywords" 
    content="Fortuner on Rent in Pune, Toyota Fortuner Hire Pune, Luxury SUV Rental Pune, Fortuner SUV Booking Pune, VIP SUV Cab Pune, Fortuner Wedding Car Pune, Fortuner for Business Travel Pune, Fortuner Outstation Cab Pune, Skyline Cabs Fortuner Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/77.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Fortuneronrentinpune;